/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IlsWithContent } from '../../models/ils-with-content';

export interface IlsControllerFindIlsWithContent$Params {
  ilsId: string;
}

export function ilsControllerFindIlsWithContent(http: HttpClient, rootUrl: string, params: IlsControllerFindIlsWithContent$Params, context?: HttpContext): Observable<StrictHttpResponse<IlsWithContent>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerFindIlsWithContent.PATH, 'get');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IlsWithContent>;
    })
  );
}

ilsControllerFindIlsWithContent.PATH = '/ils/{ilsId}/content';
